import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useLocation,
} from "react-router-dom";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import ScrollToAnchor from "./components/ScrollToAnchor";
import PrivacyNotice from "./components/PrivacyNotice";

import Hero from "./components/Hero";
import StepsToCare from "./components/StepsToCare";
import HomePage from "./components/HomePage";
import ContactUs from "./components/ContactUs";

import ServicesOverview from "./components/ServicesOverview";
import PrivateHomeCare from "./components/PrivateHomeCare";
import CCPHomeCare from "./components/CCPHomeCare";
import Career from "./components/Career";

import PrivacyPolicy from "./components/PrivacyPolicy";
import PrivacyDetails from "./components/PrivacyDetails"; // ← create if you want a separate page
import TermsOfUse from "./components/termsOfUse";
import DoNotSell from "./components/DoNotSell";
import AboutUs from "./components/AboutUs";

function Breadcrumbs() {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);
  if (location.pathname === "/") return null;

  return (
    <div className="bg-gradient-to-r from-teal-700 via-teal-600 to-emerald-500 text-white py-6 shadow-md mt-[50px]">
      <div className="max-w-6xl mx-auto px-6 text-center">
        <h1 className="text-3xl font-bold mb-2">
          {pathnames[pathnames.length - 1]
            .replace(/-/g, " ")
            .replace(/\b\w/g, (l) => l.toUpperCase())}
        </h1>
        <nav className="text-sm">
          <Link to="/" className="text-gray-200 hover:text-white underline">Home</Link>
          {pathnames.map((name, index) => {
            const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
            const isLast = index === pathnames.length - 1;
            const formatted = name.replace(/-/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
            return (
              <span key={name} className="text-gray-300">
                {" "}›{" "}
                {isLast ? (
                  <span className="text-white">{formatted}</span>
                ) : (
                  <Link to={routeTo} className="text-gray-200 hover:text-white underline">{formatted}</Link>
                )}
              </span>
            );
          })}
        </nav>
      </div>
    </div>
  );
}

export default function App() {
  useEffect(() => {
    AOS.init({ duration: 800, easing: "ease-in-out", once: true });
  }, []);

  return (
    <Router>
      <Navbar />
      <ScrollToTop />
      <ScrollToAnchor offset={140} />

      {/* top padding so content isn't hidden under the 2-row fixed header */}
      <div className="pt-[140px]">
        <Breadcrumbs />

        <Routes>
          <Route
            path="/"
            element={
              <>
                <Hero />

                {/* About section LIVES on the home page */}
                <section id="about" className="scroll-mt-40">
                  <AboutUs />
                </section>

                <StepsToCare />
                <HomePage />
                <ContactUs /> {/* ensure this contains id="contact" OR wrap it in a <section id="contact"> */}
              </>
            }
          />

          {/* Content pages */}
          <Route path="/services" element={<ServicesOverview />} />
          <Route path="/private-home-care" element={<PrivateHomeCare />} />
          <Route path="/Community-Care-Program" element={<CCPHomeCare />} />
          <Route path="/career" element={<Career />} />

          {/* Legal/privacy */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/privacy-details" element={<PrivacyDetails />} />
          <Route path="/terms" element={<TermsOfUse />} />
          <Route path="/do-not-sell" element={<DoNotSell />} />
        </Routes>
      </div>

      <Footer />

      {/* Keep a single banner instance */}
      <PrivacyNotice policyHref="/privacy-policy" detailsHref="/privacy-details" />
    </Router>
  );
}
